import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Parking } from '../models/parking.model';
import { RestService } from './rest-service.service';

@Injectable({
  providedIn: 'root'
})

export class ParkingService extends RestService<Parking>{  

  constructor(public http: HttpClient) {
    super(http, 'api/Parking');
  }  
}
